import { render, staticRenderFns } from "./ServiceTodayNoCalling.vue?vue&type=template&id=06b2c0a6&scoped=true&"
import script from "./ServiceTodayNoCalling.vue?vue&type=script&lang=js&"
export * from "./ServiceTodayNoCalling.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06b2c0a6",
  null
  
)

export default component.exports